module.exports = __webpack_public_path__ + "img/omnibox.cbcf6690.png";